import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 2rem;
  text-align: center;
`;

const ErrorTitle = styled.h2`
  color: #e74c3c;
  margin-bottom: 1rem;
`;

const ErrorMessage = styled.p`
  color: #7f8c8d;
  margin-bottom: 2rem;
  max-width: 600px;
  line-height: 1.6;
`;

const RetryButton = styled.button`
  background: #3498db;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  
  &:hover {
    background: #2980b9;
  }
`;

const DebugInfo = styled.pre`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 1rem;
  margin-top: 2rem;
  max-width: 800px;
  overflow-x: auto;
  font-size: 12px;
  text-align: left;
  border-radius: 4px;
`;

class AuthErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null,
      showDebug: false 
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    });

    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('AuthErrorBoundary caught an error:', error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null,
      showDebug: false 
    });
  };

  toggleDebug = () => {
    this.setState(prev => ({ showDebug: !prev.showDebug }));
  };

  render() {
    if (this.state.hasError) {
      const isAuthRelated = this.state.error?.message?.includes('auth') || 
                           this.state.error?.message?.includes('token') ||
                           this.state.error?.message?.includes('login');

      return (
        <ErrorContainer>
          <ErrorTitle>
            {isAuthRelated ? 'Kimlik Doğrulama Hatası' : 'Bir Hata Oluştu'}
          </ErrorTitle>
          
          <ErrorMessage>
            {isAuthRelated 
              ? 'Oturum yönetimi sırasında bir sorun oluştu. Lütfen sayfayı yenileyin veya tekrar giriş yapmayı deneyin.'
              : 'Beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin ve tekrar deneyin.'
            }
          </ErrorMessage>

          <div>
            <RetryButton onClick={this.handleRetry}>
              Tekrar Dene
            </RetryButton>
            
            {process.env.NODE_ENV === 'development' && (
              <>
                <RetryButton 
                  onClick={this.toggleDebug}
                  style={{ marginLeft: '1rem', background: '#6c757d' }}
                >
                  {this.state.showDebug ? 'Hata Detaylarını Gizle' : 'Hata Detaylarını Göster'}
                </RetryButton>
                
                {this.state.showDebug && (
                  <DebugInfo>
                    <strong>Error:</strong> {this.state.error?.toString()}
                    <br /><br />
                    <strong>Stack Trace:</strong>
                    <br />
                    {this.state.error?.stack}
                    <br /><br />
                    <strong>Component Stack:</strong>
                    <br />
                    {this.state.errorInfo?.componentStack}
                  </DebugInfo>
                )}
              </>
            )}
          </div>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default AuthErrorBoundary;
